/* Super Tiny Forest — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var STF = window.STF || { routes: {}, cartType: 'drawer' };
  var R = STF.routes;

  /* ---------- helpers ---------- */
  function setOpen(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    var anyOpen = $$('.menu-drawer.is-open, .drawer.is-open, .search-overlay.is-open, .staff-modal.is-open').length > 0;
    document.body.classList.toggle('is-locked', anyOpen);
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, a); }, ms);
    };
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* ---------- announcement rotator ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-menu-open]')) { setOpen($('[data-menu-drawer]'), true); return; }
    if (t.closest('[data-menu-close]')) { setOpen($('[data-menu-drawer]'), false); return; }

    if (t.closest('[data-search-open]')) {
      var so = $('[data-search]');
      setOpen(so, true);
      setTimeout(function () { var inp = $('[data-search-input]'); if (inp) inp.focus(); }, 250);
      return;
    }
    if (t.closest('[data-search-close]')) { setOpen($('[data-search]'), false); return; }

    var cartLink = t.closest('[data-cart-open]');
    if (cartLink && STF.cartType === 'drawer' && $('[data-cart-drawer]')) {
      e.preventDefault();
      openCart();
      return;
    }
    if (t.closest('[data-drawer-close]')) { setOpen($('[data-cart-drawer]'), false); return; }

    var lineBtn = t.closest('[data-line-qty]');
    if (lineBtn) { changeLine(parseInt(lineBtn.dataset.line, 10), parseInt(lineBtn.dataset.qty, 10)); return; }

    var prev = t.closest('[data-carousel-prev]');
    var next = t.closest('[data-carousel-next]');
    if (prev || next) {
      var car = (prev || next).closest('[data-carousel]');
      var track = $('[data-carousel-track]', car);
      var dir = prev ? -1 : 1;
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('[data-qty-input]', step.parentNode);
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
      input.value = v;
      return;
    }

    var staffOpen = t.closest('[data-staff-open]');
    if (staffOpen) { openStaff(staffOpen.dataset.staffOpen); return; }
    if (t.closest('[data-staff-close]')) { closeStaff(); return; }

    var copy = t.closest('[data-copy-link]');
    if (copy) {
      var url = copy.dataset.copyLink;
      if (navigator.clipboard) navigator.clipboard.writeText(url);
      var old = copy.textContent;
      copy.textContent = 'copied ♡';
      setTimeout(function () { copy.textContent = old; }, 1800);
      return;
    }

    var recover = t.closest('[data-recover-toggle]');
    if (recover) {
      e.preventDefault();
      var login = $('#CustomerLogin'), rec = $('#RecoverPassword');
      if (login && rec) {
        var showRecover = rec.hidden;
        rec.hidden = !showRecover;
        login.hidden = showRecover;
      }
      return;
    }

    var confirmBtn = t.closest('[data-confirm]');
    if (confirmBtn && !window.confirm(confirmBtn.dataset.confirm)) { e.preventDefault(); return; }

    var yes = t.closest('[data-age-yes]');
    if (yes) {
      try { localStorage.setItem('stf_age_ok', '1'); } catch (err) {}
      document.documentElement.classList.add('age-ok');
      return;
    }
    var no = t.closest('[data-age-no]');
    if (no) {
      var gate = $('[data-age-gate]');
      window.location.href = (gate && gate.dataset.exit) || 'https://www.google.com';
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setOpen($('[data-menu-drawer]'), false);
    setOpen($('[data-search]'), false);
    setOpen($('[data-cart-drawer]'), false);
    closeStaff();
  });

  /* ---------- auto-submit selects (localization) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-autosubmit]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- cart ---------- */
  function openCart() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) { window.location.href = R.cart; return; }
    refreshCart().then(function () { setOpen(drawer, true); });
  }

  function refreshCart() {
    var base = (R.root || '/');
    return fetch(base + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var fresh = $('[data-cart-drawer-inner]', doc);
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          updateCount(parseInt(fresh.dataset.count, 10) || 0);
        }
      })
      .catch(function () {});
  }

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function changeLine(line, quantity) {
    return fetch(R.cartChange, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        return refreshCart();
      });
  }

  // AJAX add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = $('[data-add-btn]', form) || $('button[type="submit"]', form);
    var err = $('[data-form-error]', form);
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.classList.add('is-loading'); }

    var fd = new FormData(form);
    fetch(R.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (err) { err.textContent = data.description || data.message || 'could not add to bag.'; err.hidden = false; }
          return;
        }
        if (STF.cartType === 'page') { window.location.href = R.cart; return; }
        return refreshCart().then(function () { setOpen($('[data-cart-drawer]'), true); });
      })
      .catch(function () {
        if (err) { err.textContent = 'something went wrong. please try again.'; err.hidden = false; }
      })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- predictive search ---------- */
  var searchInput = $('[data-search-input]');
  var searchResults = $('[data-search-results]');
  if (searchInput && searchResults) {
    var runSearch = debounce(function () {
      var q = searchInput.value.trim();
      if (!q) { searchResults.innerHTML = ''; return; }
      var url = R.predictive + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article&resources[limit]=4&section_id=predictive-search';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var out = $('.psearch', doc);
          searchResults.innerHTML = out ? out.outerHTML : '';
        })
        .catch(function () {});
    }, 250);
    searchInput.addEventListener('input', runSearch);
  }

  /* ---------- collection filters & sorting ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], [data-sort-select]')) form.submit();
    });
    form.addEventListener('submit', function () {
      // drop empty inputs so URLs stay clean
      $$('input', form).forEach(function (inp) {
        if (inp.type !== 'checkbox' && inp.value === '') inp.disabled = true;
      });
    });
  });

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (!el.dataset.url) return;
    fetch(el.dataset.url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        initCarousels(el);
      })
      .catch(function () {});
  });

  /* ---------- carousels: disable arrows at the ends ---------- */
  function initCarousels(scope) {
    $$('[data-carousel]', scope || document).forEach(function (car) {
      var track = $('[data-carousel-track]', car);
      var prev = $('[data-carousel-prev]', car);
      var next = $('[data-carousel-next]', car);
      if (!track || !prev || !next || car.dataset.ready) return;
      car.dataset.ready = '1';
      function update() {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      track.addEventListener('scroll', debounce(update, 40), { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      update();
    });
  }
  initCarousels();

  /* ---------- product page ---------- */
  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';

    var jsonEl = $('[data-product-json]', section);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var sectionId = section.dataset.sectionId;
    var productUrl = section.dataset.url;

    var gallery = $('[data-gallery]', section);
    var track = $('[data-gallery-track]', section);
    var slides = $$('.gallery__slide', section);
    var dots = $$('[data-dot]', section);
    var thumbs = $$('[data-thumb]', section);

    function activate(id) {
      dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.dot === id); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === id); });
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === id); });
    }

    function goTo(id) {
      var slide = slides.filter(function (s) { return s.dataset.mediaId === String(id); })[0];
      if (!slide || !track) return;
      var isGrid = getComputedStyle(track).display === 'grid';
      if (isGrid) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      activate(String(id));
    }

    function stepSlide(dir) {
      var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      var n = Math.min(slides.length - 1, Math.max(0, idx + dir));
      if (slides[n]) goTo(slides[n].dataset.mediaId);
    }

    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var d = e.target.closest('[data-dot]');
        var t = e.target.closest('[data-thumb]');
        if (d) goTo(d.dataset.dot);
        if (t) goTo(t.dataset.thumb);
        if (e.target.closest('[data-gallery-prev]')) stepSlide(-1);
        if (e.target.closest('[data-gallery-next]')) stepSlide(1);
      });
    }

    if (track && 'IntersectionObserver' in window && slides.length > 1) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) activate(en.target.dataset.mediaId);
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }

    // Variants
    var picker = $('[data-variant-picker]', section);
    if (!picker || !product) return;

    function selectedOptions() {
      return $$('.option', picker).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }

    function setUnavailable() {
      var btn = $('[data-add-btn]', section);
      if (btn) { btn.disabled = true; btn.textContent = 'unavailable'; }
    }

    picker.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      var fs = e.target.closest('.option');
      var label = $('[data-option-label]', fs);
      if (label) label.textContent = e.target.value;

      var variant = findVariant(selectedOptions());
      if (!variant) { setUnavailable(); return; }

      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', u.toString());
      }

      if (variant.featured_media && variant.featured_media.id) goTo(variant.featured_media.id);

      fetch(productUrl + '?variant=' + variant.id + '&section_id=' + sectionId, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          ['[data-price-wrap]', '[data-buy-wrap]', '[data-sku-wrap]'].forEach(function (sel) {
            var fresh = $(sel, doc), cur = $(sel, section);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
        })
        .catch(function () {});
    });
  }

  function initProducts() { $$('[data-product-section]').forEach(initProduct); }
  initProducts();
  document.addEventListener('shopify:section:load', function () { initProducts(); initCarousels(); });

  /* ---------- Forest Staff profiles ---------- */
  function openStaff(id) {
    var modal = document.getElementById(id);
    if (!modal || !modal.hasAttribute('data-staff-modal')) return;
    $$('.staff-modal.is-open').forEach(function (m) { if (m !== modal) setOpen(m, false); });
    setOpen(modal, true);
    if (window.history && window.history.replaceState) window.history.replaceState({}, '', '#' + id);
    var closeBtn = $('.staff-modal__close', modal);
    if (closeBtn) closeBtn.focus();
  }
  function closeStaff() {
    var open = $$('.staff-modal.is-open');
    if (!open.length) return;
    open.forEach(function (m) { setOpen(m, false); });
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname + window.location.search);
    }
  }
  function openFromHash() {
    var id = window.location.hash.replace('#', '');
    if (id) openStaff(id);
  }
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  /* ---------- keep cart count fresh after bfcache restore ---------- */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch(R.cartJson, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCount(c.item_count); })
      .catch(function () {});
  });
})();
